import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { lifecycle, compose } from 'recompose';
import { get } from 'lodash';
import WithShopName from '../hoc/WithShopName';
import ViewReservation from './components/ViewReservation';
import { clearReservations, fetchReservation } from '../reservation/actions';
import {
  getAppointment,
  getBarberName,
  getBarberAdvanceCancelMins,
  getCanCustomerCancel,
  getServiceName,
  getShop,
  getCustomer,
  getAppointmentInFuture,
  getAppointmentCanceled,
} from '../reservation/selectors';
import { generateUrlString } from '../utils/helpers';
import { ANY_BARBER } from '../constants';


const KIOSK_RESERVATION_TIMEOUT = 5000;
const redirectToHome = lifecycle({
  componentDidMount() {
    setTimeout(
      () => {
        this.props.router.push(this.props.redirect);
        this.props.clearReservations();
      },
      KIOSK_RESERVATION_TIMEOUT,
    );
  },
});

const mapStateToProps = (state, ownProps) => {
  const startFromAnyBarber = get(ownProps, 'location.query.startFromAnyBarber', false);
  const shop = getShop(state);
  const redirect = startFromAnyBarber ?
    generateUrlString({ shopRoute: shop.route, barberRoute: ANY_BARBER }, ownProps.urlPattern) :
    generateUrlString({ shopRoute: shop.route }, ownProps.urlPattern);

  return ({
    reservationError: state.reservation.error,
    appointment: getAppointment(state),
    barberName: getBarberName(state),
    serviceName: getServiceName(state),
    customer: getCustomer(state),
    advanceCancelMins: getBarberAdvanceCancelMins(state),
    canCustomerCancel: getCanCustomerCancel(state),
    inFuture: getAppointmentInFuture(state),
    canceled: getAppointmentCanceled(state),
    redirect,
    shop,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  fetchReservation: fetchReservation.bind(null, ownProps.params.appointmentId),
  clearReservations,
}, dispatch);


export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  WithShopName,
  redirectToHome,
)(ViewReservation);




// WEBPACK FOOTER //
// ./src/app/kiosk/ViewReservation.jsx